export const config = {
    API_URL: 'https://api.re.trackit.io',
    STRIPE_KEY:
        'pk_test_51Hjo1QIVCQo7VZFjGFRw8maCykxJLXYsETrN3dgvgQ92g7dQ2l93AHz29YaCGxWQI3G2z1DMZeQbm6BvqKQjXoK700HnbxyUms',
    SEGMENT_KEY: 'ylFcXe45aXyCeG8Nj9T1x1RlxmRcFejq',
};
